module.exports = __webpack_public_path__ + "img/failed.3e7b31ee.svg";